import React from "react";
import shieldImg from "../../../assets/images/shield.png";

function TrustedMemberBadge() {
  return (
    <span className="badge" style={{ backgroundColor: "#9E9E9E" }}>
      <img
        src={shieldImg}
        alt="sheild image"
        className="me-2"
        style={{ width: "16px" }}
      />
      <span style={{ fontSize: "12px" }} className="text-white">
        Trusted Member
      </span>
    </span>
  );
}

export default TrustedMemberBadge;
